export default {
	name: 'Användare',
	slug: 'users',
	methods: ['DELETE', 'EDIT', 'CREATE'],
	icon: 'user',
	description: '',
	template: {
		name: 'Name',
		component: 'EditUser'
	},
	createTemplate: {
		component: 'CreateUser'
	},
	quickEdit: [
		'Name',
		'LastName',
		'Email',
		'EmployeeNumber',
		'Password',
	],
	fieldGroups: [
		{
			key: 'info',
			name: 'Allmänt',
			fields: [
				{
					key: 'Name',
					type: 'text'
				},
				{
					key: 'LastName',
					type: 'text'
				},
				{
					key: 'Email',
					type: 'email'
				},
				{
					key: 'Password',
					type: 'password'
				},
				{
					key: 'EmployeeNumber',
					type: 'number'
				},
				{
					key: 'Pin',
					type: 'number'
				}
			]
		}
	],
	head: [
		{ Alias: "Id", Value: "ID" },
		{ Alias: "Name", Value: "Namn" },
		{ Alias: "LastName", Value: "Efternamn" },
		{ Alias: "LastLogin", Value: "Senast inloggad" },
		{ Alias: "EmployeeNumber", Value: "Anställningsnummer", HideField: true },
		{ Alias: "Pin", Value: "Pin", HideField: true },
		{ Alias: "Password", Value: "Lösenord", HideField: true },
		{ Alias: "Email", Value: "Epost" },
		{ Alias: "AccountPermission", Value: "Behörighet" },
		{ Alias: "CustomerName", Value: "Företag" },
	]
}